<template>
    <div class="user-dashboard">
        <div class="dashboard-layout">
            <!-- 左侧栏 - 盒子选择区域 -->
            <div class="left-panel">
                <box-selector @box-selected="handleBoxSelected" />
            </div>

            <!-- 中间栏 - MQTT操作区域 -->
            <div class="center-panel">
                <mqtt-operations
                    :selected-box="selectedBox"
                    @command-sent="handleCommandSent" />
            </div>

            <!-- 右侧栏 - 实时日志显示区域 -->
            <div class="right-panel">
                <realtime-logs
                    ref="logsComponent"
                    :selected-box="selectedBox" />
            </div>
        </div>
    </div>
</template>

<script>
import {ref, onMounted} from 'vue';
import BoxSelector from './box-selector.vue';
import MqttOperations from './mqtt-operations.vue';
import RealtimeLogs from './realtime-logs.vue';
import {nowUtcISOString} from '../../assets/js/time.js';

export default {
    name: 'UserDashboard',
    components: {
        BoxSelector,
        MqttOperations,
        RealtimeLogs,
    },
    setup() {
        const selectedBox = ref(null);
        const logsComponent = ref(null);

        // 处理盒子选择
        const handleBoxSelected = (box) => {
            selectedBox.value = box;
            console.log('Box selected:', box);
        };

        // 处理命令发送
        const handleCommandSent = (commandData) => {
            if (logsComponent.value) {
                logsComponent.value.addCommandLog(commandData);
                // 模拟MQTT消息接收（实际应该通过WebSocket或SSE接收）
                setTimeout(() => {
                    const responseData = {
                        message_id: commandData.data.message_id,
                        status: 'success',
                        data: {
                            // 根据命令类型返回不同的模拟数据
                            ...(commandData.type === 'measure' && {
                                voltage: 12000,
                                resistance: 15000,
                                temperature: 250,
                            }),
                            ...(commandData.type === 'query' && {
                                status: 'online',
                                config: {},
                            }),
                            ...(commandData.type === 'config' && {
                                result: 'config_updated',
                            }),
                        },
                        timestamp: nowUtcISOString(),
                    };

                    logsComponent.value.addResultLog({
                        success: true,
                        type: commandData.type,
                        data: responseData,
                    });
                }, 2000); // 2秒后模拟响应
            }
        };

        // 组件挂载时
        onMounted(() => {
            console.log('User dashboard mounted');
        });

        return {
            selectedBox,
            logsComponent,
            handleBoxSelected,
            handleCommandSent,
        };
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.user-dashboard {
  height: 100vh;
  padding: 16px;
  box-sizing: border-box;
}

.dashboard-layout {
  display: flex;
  height: 100%;
  gap: 16px;
}

.left-panel {
  flex: 0 0 300px;
  min-width: 300px;
}

.center-panel {
  flex: 0 0 400px;
  min-width: 400px;
}

.right-panel {
  flex: 1;
  min-width: 400px;
}

/* 响应式布局 */
@media (max-width: 1400px) {
  .dashboard-layout {
    flex-direction: column;
  }

  .left-panel, .center-panel, .right-panel {
    flex: 1;
    min-width: auto;
    width: 100%;
  }
}
</style>
